import { render } from "./ResultsComponent.vue?vue&type=template&id=be29443c&scoped=true"
import script from "./ResultsComponent.vue?vue&type=script&lang=js"
export * from "./ResultsComponent.vue?vue&type=script&lang=js"

import "./ResultsComponent.vue?vue&type=style&index=0&id=be29443c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be29443c"]])

export default __exports__